import { mdiAccountMultiple, mdiAccountMultipleOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { IconProps } from '.'

const MembersIcon = (props: IconProps) => {
    const { filled = false, size = 1, ...other } = props
    return (
        <Icon
            data-testid="IconButton__Members"
            path={filled ? mdiAccountMultiple : mdiAccountMultipleOutline}
            size={size}
            {...other}
        />
    )
}

export default MembersIcon
